const { uwmLightTheme, uwmDarkTheme } = require('./src/theme');

module.exports = {
  uwmLightTheme,
  uwmDarkTheme,
};
